import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { MachinesRequestRemoteMachineAccessDrawerModal } from "@src/components/organisms/modals/machines-request-remote-machine-access-drawer-modal/machines-request-remote-machine-access-drawer-modal";

export const RequestRemoteMachineAccessDrawer = () => {
  const showModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals
        .machinesRequestRemoteMachineAccessDrawerModal.showModal,
  );
  return (
    <>
      {showModal && <MachinesRequestRemoteMachineAccessDrawerModal />}
    </>
  );
};
